import { max, parse } from "../fable_modules/fable-library-js.4.29.0/Double.js";
import { substring } from "../fable_modules/fable-library-js.4.29.0/String.js";

const Values_root = document.documentElement;

function Values_setVar(name, value) {
    return Values_root.style.setProperty((`--${name}`), value);
}

function Values_setPx(name, px) {
    return Values_setVar(name, `${Math.ceil(px)}px`);
}

export const Values_fontPx = (() => {
    const fontSize = (window.getComputedStyle(Values_root)).getPropertyValue("font-size");
    const value_1 = parse(substring(fontSize, 0, fontSize.length - 2));
    return Math.ceil(value_1);
})();

Values_setPx("border-thin", max(1, Values_fontPx / 8));

Values_setPx("border-med", max(1.5, Values_fontPx / 6));

//# sourceMappingURL=Style.js.map
